import * as React from "react";
import { useSearchParams } from "react-router-dom";

// 상태를 URL 쿼리 파라미터에 동기화 (뒤로가기/새로고침 시 복원).
// 값이 초기값과 같거나 비면 파라미터 제거. replace 로 필터마다 history 안 쌓음.
//
// setter 는 ref 로 고정해 **identity 가 안 바뀌게** 한다. (useSearchParams 의
// setSp 는 URL 이 바뀔 때마다 identity 가 바뀌는데, 그걸 effect 의존성에 쓰면
// 페이지 이동만 해도 필터-리셋 effect 가 다시 돌아 page 가 1로 튄다.)
export function useUrlState(
  key: string,
  initial: string,
): [string, (v: string) => void] {
  const [sp, setSp] = useSearchParams();
  const value = sp.get(key) ?? initial;
  const setSpRef = React.useRef(setSp);
  setSpRef.current = setSp;
  const set = React.useCallback(
    (v: string) => {
      setSpRef.current(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (!v || v === initial) next.delete(key);
          else next.set(key, v);
          return next;
        },
        { replace: true },
      );
    },
    [key, initial],
  );
  return [value, set];
}
